module.exports = __webpack_public_path__ + "static/media/Recom_action_grey.20fc7f90.svg";